import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { useBreadcrumbs } from '../layout/breadcrumbsContext/useBreadcrumbs/useBreadcrumbs'
import { RoutePath } from '../layout/Routes'

import {
  OrganisationProfile,
  OrganisationProfileLinks,
  RenderOrganisationProfileLink
} from '@percent/domain/organisation-profile'
import { useCountries } from '@percent/partner-dashboard/common/hooks/useCountries/useCountries'
import { useCountryFromIp } from '@percent/partner-dashboard/common/hooks/useCountryFromIp/useCountryFromIp'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

const links: OrganisationProfileLinks = {
  organisation: organisationId => RoutePath.ORGANISATION.replace(':organisationId', organisationId)
}

const renderLink: RenderOrganisationProfileLink = ({ href, ...props }) => <Link to={href} {...props} />

export function OrganisationsContainer() {
  const { t, i18n } = useTranslation()
  const { organisationProfileService } = useServices()
  const { countries } = useCountries()
  const { country } = useCountryFromIp()

  useBreadcrumbs([
    {
      label: t('breadcrumb.organisations')
    }
  ])

  return (
    <OrganisationProfile.Provider
      service={organisationProfileService}
      locale={i18n.language}
      countries={countries ?? undefined}
      links={links}
      renderLink={renderLink}
    >
      <OrganisationProfile.Directory defaultCountryCode={country} />
    </OrganisationProfile.Provider>
  )
}
